import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  about?: string;
  address?: string;
  description?: string;
  email?: string;
  websites?: string[];
  vertical?: string;
  from_number?: string;
};

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

export const useUpdateWhatsappProfileMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while updating WhatsApp Profile',
    endpoint: '/api/admin/whatsapp/profile',
    method: 'PUT',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};